import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../_services/api.service";
import {ActivatedRoute} from "@angular/router";
import {ReportOfReservationsModel} from "../../_models/Report/ReportOfReservationsModel";
import * as moment from "moment/moment";
import {
  TotalReservationsForVenueRequestDTO
} from "../../_models/Report/TotalReservationsForVenueModelDTO";
import {ReservationsStatisticsModel} from "../../_models/Report/ReservationsStatisticsModel";
import {MostVisitedEventsRequestDTO} from "../../_models/Report/MostVisitedEventsModelDTO";
import {Chart, Colors} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {UpcomingEventReservationsModelDTO} from "../../_models/Report/UpcomingEventReservationsModelDTO";
import {ReservationsDetailsForEventModelDTO} from "../../_models/Report/ReservationsDetailsForEventModelDTO";
import {VenueModelResponse} from "../../_models/Venue/VenueModel";
import {WeeklyReservationsModelDTO} from "../../_models/Report/WeeklyReservationsModelDTO";
Chart.register(ChartDataLabels);
import * as FileSaver from "file-saver";
import {
  PastOrUpcomingEventReservationsRequestDTO
} from "../../_models/Report/PastOrUpcomingEventReservationsRequestDTO";
import {PastEventReservationsModel} from "../../_models/Report/PastEventReservationsModel";
import {UpcomingEventReservationsModel} from "../../_models/Report/UpcomingEventReservationsModel";
import {ReservationStatusEnum} from "../../_models/Enums/ReservationStatus.enum";

export enum ReportOption {
  DownloadFile = 0,
  SendFileToEmail
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  venueId: string;
  venueDetails: VenueModelResponse = new VenueModelResponse();
  reportFileOptions: any = [{label: "Download excel", value: ReportOption.DownloadFile}, {label: "Send to mail", value: ReportOption.SendFileToEmail}];
  weeklyReservations: Array<ReportOfReservationsModel>;
  weeklyResWeekFormat: any = {};
  weeklyResWeekFormatOptions: any = [{label: "Mon-Sun", value: true}, {label: "Sun-Mon", value: false}];
  weeklyResReportChoice: any = {};
  dataChartWeeklyReservations: any;
  optionsChartWeeklyReservations: any;
  reservationsStatistics: ReservationsStatisticsModel = new ReservationsStatisticsModel();
  reservationsStatisticsDates: Date[] | undefined;
  totalResReportChoice: any = {};
  mostVisitedEvents: Array<any> = new Array<any>();
  mostVisitedEventsDates: Date[] | undefined;
  mostVisitedEventsReportChoice: any = {};
  dataChartMostVisitedEvents: any;
  mostVisitedEventsOptions: any;
  upcomingEventsStatistics: Array<any> = new Array<any>();
  upcomingEventsStatisticsReportChoice: any = {};
  upcomingEventsStatisticsDates: Date[] | undefined;
  minDateUpcomingEventsStatistics: Date;
  dataChartUpcomingEventsStatistics: any;
  upcomingEventsStatisticsOptions: any;
  pastReservationDetails: Array<PastEventReservationsModel> = new Array<PastEventReservationsModel>();
  pastEvents: Array<any> = new Array<any>();
  showPastEventReservations: any | undefined;
  pastEventsReservationsReportChoice: any = {};
  upcomingReservationDetails: Array<UpcomingEventReservationsModel> = new Array<UpcomingEventReservationsModel>();
  upcomingEvents: Array<any> = new Array<any>();
  showUpcomingEventReservations: any | undefined;
  upcomingEventsReservationsReportChoice: any = {};
  reservationStatus = ReservationStatusEnum;

  constructor(private apiService: ApiService,
              public route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.venueId = params['venue-id'];
      this.minDateUpcomingEventsStatistics = new Date();
      this.apiService.getVenue(this.venueId).subscribe(response => this.venueDetails = response);
      this.displayWeeklyReservations();
      this.getReservationsStatistics();
      this.getMostVisitedEvents();
      this.getUpcomingEventReservationStatistics();
      this.apiService.getPastEventsForVenue(this.venueId).subscribe(response => {
        this.pastEvents = response;
        console.log(response)
        this.getPastReservationsDetails();
      });
      this.apiService.getUpcomingEventsForVenue(this.venueId).subscribe(response => {
        this.upcomingEvents = response;
        this.getUpcomingReservationsDetails();
      })
    });
  }

  displayWeeklyReservations(){
    let model = new WeeklyReservationsModelDTO(this.venueId, Object.keys(this.weeklyResWeekFormat).length == 0 ? true : this.weeklyResWeekFormat.value );
    this.apiService.getWeeklyReservationsForVenue(model).subscribe(response => {
      this.weeklyReservations = response;
      this.dataChartWeeklyReservations = {
        datasets: [{
          data: this.weeklyReservations,
          backgroundColor: (context: any) =>{
            if(context.type == 'data'){
              return moment(context.raw['date']).utc(true) < moment.utc() ? '#00FFFF' : '#FF00FF';
            }
            return;
          },
          xAxisID: 'x',
          segment: {
            borderColor: (context: any) => moment(context.p0.raw['date']).utc(true) < moment.utc() ? '#00FFFF' : '#FF00FF',
          }
        }]
      };

      this.optionsChartWeeklyReservations = {
        parsing: {
          xAxisKey: 'dayOfTheWeek',
          yAxisKey: 'reservationCount'
        },
        scales:{
          y: {
            ticks: {
              display: false
            },
            border: {
              display: true,
              color: '#ffffff',
              z: 1
            },
            grid: {
              drawBorder: true,
            }
          },
          x1: {
            type: 'linear',
            display: true,
            z: 0,
            position: 'top',
            ticks: {
              display: false
            },
            border: {
              display: true,
              color: '#ffffff',
              z: 1
            },
          },
          x: {
            ticks: {
              padding: 10
            },
            border: {
              display: true,
              color: '#ffffff',
              z: 1
            },
            grid: {
              display: true,
              color: '#ffffff',
              drawTicks: false
            },
          }
        },
        plugins: {
          legend: {
            labels:{
              usePointStyle: true,
              generateLabels: function() {
                return [{
                    text: "Past",
                    borderRadius: 5,
                    fillStyle: '#00ffff',
                    fontColor: '#ffffff',
                    pointStyle: 'circle'},
                  {
                    text: "Upcoming",
                    borderRadius: 5,
                    fillStyle: '#ff00ff',
                    fontColor: '#ffffff',
                    pointStyle: 'circle'}
                ]}
            }
          },
          datalabels: false
        }
      }
    });
  }

  downloadOrSendWeeklyReservationsReport(){
    if(Object.keys(this.weeklyResReportChoice).length != 0) {
      let model = new WeeklyReservationsModelDTO(this.venueId, Object.keys(this.weeklyResWeekFormat).length == 0 ? true : this.weeklyResWeekFormat.value);
      if (this.weeklyResReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadWeeklyReservationsForVenue(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-WeeklyReservationsReport";
          FileSaver.saveAs(response, title);
          this.weeklyResReportChoice = {};
        });
      } else {
        this.apiService.sendToMailWeeklyReservationsForVenue(model).subscribe(response => {
          this.weeklyResReportChoice = {};
        });
      }
    }
  }

  getReservationsStatistics(){
    let model = new TotalReservationsForVenueRequestDTO(this.venueId);
    if (this.reservationsStatisticsDates != undefined && this.reservationsStatisticsDates[1] != null ) {
      model.dateFrom = moment(this.reservationsStatisticsDates[0]).utc(true).toISOString();
      model.dateTo = moment(this.reservationsStatisticsDates[1]).utc(true).endOf('day').toISOString();
    }
    this.apiService.getTotalReservationsForVenue(model).subscribe(response => {
      this.reservationsStatistics = response;
    })
  }

  downloadOrSendTotalReservationsReport(){
    if(Object.keys(this.totalResReportChoice).length != 0) {
      let model = new TotalReservationsForVenueRequestDTO(this.venueId);
      if (this.reservationsStatisticsDates != undefined && this.reservationsStatisticsDates[1] != null ) {
        model.dateFrom = moment(this.reservationsStatisticsDates[0]).utc(true).toISOString();
        model.dateTo = moment(this.reservationsStatisticsDates[1]).utc(true).endOf('day').toISOString();
      }
      if (this.totalResReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadTotalReservationsForVenue(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-TotalReservationsReport";
          FileSaver.saveAs(response, title);
          this.totalResReportChoice = {};
        });
      } else {
        this.apiService.sendToMailTotalReservationsForVenue(model).subscribe(response => {
          this.totalResReportChoice = {};
        });
      }
    }
  }

  getMostVisitedEvents() {
    let model = new MostVisitedEventsRequestDTO(this.venueId);
    model.pageNumber = 1;
    model.pageSize = 20;
    if (this.mostVisitedEventsDates != undefined && this.mostVisitedEventsDates[1] != null) {
      model.dateFrom = moment(this.mostVisitedEventsDates[0]).utc(true).toISOString();
      model.dateTo = moment(this.mostVisitedEventsDates[1]).utc(true).endOf('day').toISOString();
    } else {
      model.dateFrom = moment.utc().subtract(7, "days").startOf('day').toISOString();
      model.dateFrom = moment.utc().subtract(1, "days").endOf('day').toISOString();
    }
    if (this.mostVisitedEventsDates == undefined || this.mostVisitedEventsDates[1] != null) {
      this.apiService.getMostVisitedEvents(model).subscribe(response => {
        this.mostVisitedEvents = response.data;
        this.dataChartMostVisitedEvents = {
          datasets: [
            {
              borderRadius: 4,
              barPercentage: 1,
              categoryPercentage: 1,
              backgroundColor: ['#F72585', '#B5179E', '#7209B7', '#560BAD'],
              data: [...this.mostVisitedEvents].sort(function (first: any, second: any) {
                return (second.totalReservations - first.totalReservations);
              })
            },
          ]
        };

        this.mostVisitedEventsOptions = {
          aspectRatio: 0.8,
          indexAxis: 'y',
          layout: {
            padding: {
              right: 40
            }
          },
          parsing: {
            xAxisKey: 'totalReservations',
            yAxisKey: 'eventName'
          },
          plugins: {
            legend: {
              display: false
            },
            datalabels: {
              color: '#ffffff',
              formatter: function (value: any, context: any) {
                  return value.totalReservations + " reservations";
              },
              anchor: 'end',
              align: 'end',
            }
          },
          scales: {
            x: {
              display: false
            },
            y: {
              ticks: {
                color: '#ffffff',
                mirror: true,
                z: 1
              },
            }
          }
        };
      });
    }
  }

  downloadOrSendMostVisitedEventsReport() {
    if(Object.keys(this.mostVisitedEventsReportChoice).length != 0) {
      let model = new MostVisitedEventsRequestDTO(this.venueId);
      if (this.mostVisitedEventsDates != undefined && this.mostVisitedEventsDates[1] != null ) {
        model.dateFrom = moment(this.mostVisitedEventsDates[0]).utc(true).toISOString();
        model.dateTo = moment(this.mostVisitedEventsDates[1]).utc(true).endOf('day').toISOString();
      }
      if (this.mostVisitedEventsReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadMostVisitedEventsForVenue(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-MostVisitedEventsReservations";
          FileSaver.saveAs(response, title);
          this.mostVisitedEventsReportChoice = {};
        });
      } else {
        this.apiService.sendToMailMostVisitedEventsForVenue(model).subscribe(response => {
          this.mostVisitedEventsReportChoice = {};
        });
      }
    }
  }

  getUpcomingEventReservationStatistics() {
    let model = new UpcomingEventReservationsModelDTO(this.venueId);
    model.pageNumber = 1;
    model.pageSize = 20;
    if (this.upcomingEventsStatisticsDates != undefined && this.upcomingEventsStatisticsDates[1] != null) {
      model.dateFrom = moment(this.upcomingEventsStatisticsDates[0]).utc(true).toISOString();
      model.dateTo = moment(this.upcomingEventsStatisticsDates[1]).utc(true).endOf('day').toISOString();
    } else {
      model.dateFrom = moment.utc().add(1, "days").startOf('day').toISOString();
      model.dateFrom = moment.utc().add(7, "days").endOf('day').toISOString()
    }
    if (this.upcomingEventsStatisticsDates == undefined || this.upcomingEventsStatisticsDates[1] != null) {
      this.apiService.getUpcomingEventReservationStatistics(model).subscribe(response => {
        this.upcomingEventsStatistics = response.data;

        this.dataChartUpcomingEventsStatistics = {
          datasets: [
            {
              borderRadius: 4,
              barPercentage: 1,
              categoryPercentage: 1,
              backgroundColor: ['#2592F7', '#17B5B5', '#0BAD5F', '#2673BF', '#0B25AD'],
              data: [...this.upcomingEventsStatistics].sort(function (first: any, second: any) {
                return (second.totalReservations - first.totalReservations);
              })
            },
          ]
        };

        this.upcomingEventsStatisticsOptions = {
          aspectRatio: 0.4,
          indexAxis: 'y',
          parsing: {
            xAxisKey: 'totalReservations',
            yAxisKey: 'eventName'
          },
          layout: {
            padding: {
              right: 30
            }
          },
          plugins: {
            legend: {
              display: false
            },
            datalabels: {
              color: '#ffffff',
              formatter: function (value: any, context: any) {
                  return value.totalReservations;
              },
              anchor: 'end',
              align: 'end',
            }
          },
          scales: {
            x: {
              display: false
            },
            y: {
              ticks: {
                color: '#ffffff',
                mirror: true,
                z: 1
              },
            }
          }
        };
      });
    }
  }

  downloadOrSendUpcomingEventReservationStatistics() {
    if(Object.keys(this.upcomingEventsStatisticsReportChoice).length != 0) {
      let model = new UpcomingEventReservationsModelDTO(this.venueId);
      if (this.upcomingEventsStatisticsDates != undefined && this.upcomingEventsStatisticsDates[1] != null ) {
        model.dateFrom = moment(this.upcomingEventsStatisticsDates[0]).utc(true).toISOString();
        model.dateTo = moment(this.upcomingEventsStatisticsDates[1]).utc(true).endOf('day').toISOString();
      }
      if (this.upcomingEventsStatisticsReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadUpcomingEventReservationStatistics(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-UpcomingEventReservationsStatistics";
          FileSaver.saveAs(response, title);
          this.upcomingEventsStatisticsReportChoice = {};
        });
      } else {
        this.apiService.sendToMailUpcomingEventReservationStatistics(model).subscribe(response => {
          this.upcomingEventsStatisticsReportChoice = {};
        });
      }
    }
  }


  getPastReservationsDetails() {
    if(this.showPastEventReservations != undefined) {
      let model = new ReservationsDetailsForEventModelDTO(this.venueId, this.showPastEventReservations.id, 20, 1);
      this.apiService.getPastReservationsDetails(model).subscribe(response => {
        this.pastReservationDetails = response.data;
      });
    }
  }
  downloadOrSendPastEventReservations() {
    if(Object.keys(this.pastEventsReservationsReportChoice).length != 0) {
      let model = new PastOrUpcomingEventReservationsRequestDTO(this.venueId);
      if (this.pastEventsReservationsReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadPastEventsReservations(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-PastEventsReservations";
          FileSaver.saveAs(response, title);
          this.pastEventsReservationsReportChoice = {};
        });
      } else {
        this.apiService.sendToMailPastEventsReservations(model).subscribe(response => {
          this.pastEventsReservationsReportChoice = {};
        });
      }
    }
  }

  getUpcomingReservationsDetails(){
    if(this.showUpcomingEventReservations != undefined) {
      let model = new ReservationsDetailsForEventModelDTO(this.venueId, this.showUpcomingEventReservations.id, 20, 1);
      this.apiService.getUpcomingReservationsDetails(model).subscribe(response => {
        this.upcomingReservationDetails = response.data;
      });
    }
  }

  downloadOrSendUpcomingEventReservations() {
    if(Object.keys(this.upcomingEventsReservationsReportChoice).length != 0) {
      let model = new PastOrUpcomingEventReservationsRequestDTO(this.venueId);

      if (this.upcomingEventsReservationsReportChoice.value == ReportOption.DownloadFile) {
        this.apiService.downloadUpcomingEventsReservations(model).subscribe((response: Blob) => {
          let title = this.venueDetails.name + "-UpcomingEventReservationsStatistics";
          FileSaver.saveAs(response, title);
          this.upcomingEventsReservationsReportChoice = {};
        });
      } else {
        this.apiService.sendToMailUpcomingEventsReservations(model).subscribe(response => {
          this.upcomingEventsReservationsReportChoice = {};
        });
      }
    }
  }


}
